import { Component, OnInit, AfterViewInit, TemplateRef, ViewChild, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ManagerService } from 'src/app/core';
import { PopupMessageService } from 'src/app/shared/message/services/message.service';
import { DataTableColumn } from 'src/app/shared/ui/data-table/data-table.component';

@Component({
  selector: 'app-view-leaderboard-challenge',
  templateUrl: './view-leaderboard-challenge.component.html',
  styleUrls: ['./view-leaderboard-challenge.component.scss']
})
export class ViewLeaderboardChallengeComponent implements OnInit, AfterViewInit {

  @ViewChild('nameTpl') nameTpl!: TemplateRef<any>;
  @ViewChild('startDateTpl') startDateTpl!: TemplateRef<any>;
  @ViewChild('endDateTpl') endDateTpl!: TemplateRef<any>;
  @ViewChild('updatedDateTpl') updatedDateTpl!: TemplateRef<any>;
  @ViewChild('statusTpl') statusTpl!: TemplateRef<any>;
  @ViewChild('actionTpl') actionTpl!: TemplateRef<any>;
  @ViewChild('editTpl') editTpl!: TemplateRef<any>;

  documentsModalOpen: boolean = false;
  documentsModalData: any = null;
  documentsModalName: string = '';

  constructor(private managerService: ManagerService, private popupMessageService: PopupMessageService,
    private translate: TranslateService) { }
  @Input() isCiscoAdmin: boolean = false;
  viewLeaderBoardsFlag: boolean = false;
  deleteChallengeModalOpen: boolean = false;
  pendingDeleteChallengeId: any = null;
  statusConfirmModalOpen: boolean = false;
  pendingStatusChallengeData: any = null;
  editedLeaderChallengeData: any;
  copyLeaderChallengeData: any;
  dataSource: any = { content: [], totalElements: 0 };
  leaderboardColumns: DataTableColumn[] = [];
  pageSize = 5;
  pageNo = 0;

  ngOnInit() {
    this.getLeaderBoardChallengesList();
  }

  ngAfterViewInit() {
    this.leaderboardColumns = [
      { field: 'name', header: this.translate.instant('manageActivity.challengeName1'), align: 'left', cellTemplate: this.nameTpl },
      { field: 'fiscalYear', header: this.translate.instant('manageActivity.fiscalYear'), align: 'left' },
      { field: 'participantType', header: this.translate.instant('manageActivity.participantType'), align: 'left' },
      { field: 'startDate', header: this.translate.instant('manageActivity.startDate'), align: 'left', cellTemplate: this.startDateTpl },
      { field: 'endDate', header: this.translate.instant('manageActivity.endDate'), align: 'left', cellTemplate: this.endDateTpl },
      {
        field: 'modifiedOn',
        header: this.translate.instant('manageActivity.updatedDate'),
        align: 'left',
        cellTemplate: this.updatedDateTpl
      },
      { field: 'status', header: this.translate.instant('manageActivity.leaderStatus'), align: 'left', cellTemplate: this.statusTpl },
      { field: 'action', header: this.translate.instant('manageActivity.Action'), align: 'left', cellTemplate: this.actionTpl },
      { field: 'edit', header: '', align: 'right', cellTemplate: this.editTpl },
    ];
  }

  getLeaderBoardChallengesList() {
    const params = {
      page: this.pageNo,
      size: this.pageSize,
    };

    this.managerService.getLeaderBoardChallengesListCiscoAdmin('?page='+params.page+'&size='+params.size).subscribe((data: any) => {
      this.dataSource = data;
    }, (_err: any) => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  onPageChange(page: number) {
    this.pageNo = page - 1;
    this.getLeaderBoardChallengesList();
  }

  editLeaderboardChallenge(element: any) {
    this.editedLeaderChallengeData = element;
    this.copyLeaderChallengeData = null;
    this.viewLeaderBoardsFlag = true;
  }

  copyContent(element: any) {
    this.copyLeaderChallengeData = element;
    this.editedLeaderChallengeData = null;
    this.viewLeaderBoardsFlag = true;
  }

  showOrHideCreateLeaderBoardsLayout() {
    this.editedLeaderChallengeData = null;
    this.copyLeaderChallengeData = null;
    this.viewLeaderBoardsFlag = !this.viewLeaderBoardsFlag;
  }

  deleteChallenge(challengeId: any) {
    this.pendingDeleteChallengeId = challengeId;
    this.deleteChallengeModalOpen = true;
  }

  closeDeleteChallengeModal() {
    this.deleteChallengeModalOpen = false;
    this.pendingDeleteChallengeId = null;
  }

  onDeleteChallengeConfirm() {
    this.deleteChallengeModalOpen = false;
    this.managerService.deleteLeaderboardChallengeById(this.pendingDeleteChallengeId).subscribe((_data: any) => {
      this.popupMessageService.showSuccess(this.translate.instant('manageActivity.challengeDeletedSuccess'), 'success');
      this.pendingDeleteChallengeId = null;
      this.getLeaderBoardChallengesList();
    }, (_err: any) => {
      this.popupMessageService.showError(this.translate.instant('manageActivity.challengeDeleteError'), 'error');
    });
  }

  showConfirmation(challengeData: any) {
    this.pendingStatusChallengeData = challengeData;
    this.statusConfirmModalOpen = true;
  }

  closeStatusConfirmModal() {
    this.statusConfirmModalOpen = false;
    this.pendingStatusChallengeData = null;
  }

  onStatusConfirmConfirm() {
    const params = {
      id: this.pendingStatusChallengeData.id,
      status: 'ACTIVE'
    };
    this.statusConfirmModalOpen = false;
    this.managerService.updateLeaderboardChallengeStatus(params).subscribe((_data: any) => {
      this.popupMessageService.showSuccess(this.translate.instant('manageActivity.statusUpdatedSuccess'), 'success');
      this.pendingStatusChallengeData = null;
      this.getLeaderBoardChallengesList();
    }, (_err: any) => {
      this.popupMessageService.showError(this.translate.instant('manageActivity.challengeDeleteError'), 'error');
    });
  }

  showUploadDocumentPopUp(list: any, fileName: any, showOnlyTerms = false) {
    if (showOnlyTerms) {
      const win = window.open(list.termsAndConditionsUrl, '_blank');
      if (win) { win.focus(); }
    } else {
      this.documentsModalData = { fileData: list, name: fileName, showOnlyTerms, path: 'leaderboard' };
      this.documentsModalName = fileName;
      this.documentsModalOpen = true;
    }
  }

  closeDocumentsModal() {
    this.documentsModalOpen = false;
    this.documentsModalData = null;
    this.documentsModalName = '';
    this.getLeaderBoardChallengesList();
  }
}
